import { render, staticRenderFns } from "./EditDepoModal.vue?vue&type=template&id=225ac6f8&"
import script from "./EditDepoModal.vue?vue&type=script&lang=js&"
export * from "./EditDepoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports